"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAlertEmail = exports.templateIsEmpty = exports.getEmptyTemplate = exports.parseAlertEmailString = exports.parseTemplate = void 0;
var uuid_1 = require("uuid");
function parseTemplate(template) {
    if (template.name == null || template.alertEmailString == null || template.parser == null) {
        return { key: 'incomplete' };
    }
    var alertEmailResult = parseAlertEmailString(template.alertEmailString);
    if (alertEmailResult.key == 'error') {
        return { key: 'alertEmailError', message: alertEmailResult.message };
    }
    return {
        key: 'ok',
        param: {
            id: template.id,
            unitKey: template.unitKey,
            name: template.name,
            alertEmails: alertEmailResult.alertEmails,
            parser: template.parser,
        },
    };
}
exports.parseTemplate = parseTemplate;
function parseAlertEmailString(s) {
    var alertEmailTokens = s.split(',').map(function (t) { return t.trim(); });
    if (!alertEmailTokens.every(function (t) { return t != ''; })) {
        return { key: 'error', message: 'Incomplete string' };
    }
    else if (!alertEmailTokens.every(function (t) { return t.indexOf('@') == -1; })) {
        return { key: 'error', message: 'Alert emails must be local-part only' };
    }
    return { key: 'ok', alertEmails: alertEmailTokens };
}
exports.parseAlertEmailString = parseAlertEmailString;
function getEmptyTemplate() {
    return {
        id: uuid_1.v4(),
        unitKey: null,
        name: null,
        alertEmailString: null,
        parser: null,
    };
}
exports.getEmptyTemplate = getEmptyTemplate;
function templateIsEmpty(t) {
    return t.unitKey == null && t.name == null && t.alertEmailString == null && t.parser == null;
}
exports.templateIsEmpty = templateIsEmpty;
function getAlertEmail() {
    return uuid_1.v4().replace(/-/g, '');
}
exports.getAlertEmail = getAlertEmail;
//# sourceMappingURL=unitTemplate.js.map